import { format as dateFnsFormat } from 'date-fns';
import { ru } from 'date-fns/locale';
import i18n from './i18n';

const locales = { ru };

// eslint-disable-next-line import/prefer-default-export
export function format(date, formatStr = 'PP') {
  return dateFnsFormat(date, formatStr, { locale: locales[i18n.locale] });
}

export const DATE_FORMATS = Object.freeze({
  server: {
    short: 'yyyy-MM-dd',
  },
  en: {
    short: 'MM/dd/yyyy',
  },
  ru: {
    short: 'dd.MM.yyyy',
  },
});

export const DATE_MASKS = Object.freeze({
  en: {
    short: '##/##/#####',
  },
  ru: {
    short: '##.##.####',
  },
});
